export type PolicyOverdueDebtType = 'V' | 'T';
export enum POLICY_OVERDUE_DEBT_TYPE {
    VENCIDAS = 'V',
    TODAS = 'T',
}